// extracted by mini-css-extract-plugin
export default {"table":"styles_table__TkERl","head":"styles_head__Nl05J","row":"styles_row__WtwfM","data":"styles_data__wO8Ui"};